import {handleLogout} from "components/utils";
import React, {useEffect, useState} from 'react';
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableColumnType,
    TableHeader
} from "react-bs-datatable";
import {Button, Col, Form, Modal, Row, Tab, Table, Tabs} from "react-bootstrap";
import axios from "axios";
import {MedicalServiceView} from "../services/MedicalServiceView";
import {AddDiagnosticServicesView} from "../../diagnostics/AddDiagnosticServicesView";

export const MedicalServicesView = (props: { cookieEntityQr: string, category: string }) => {

    const [items, setItems] = useState<Array<any>>([]);

    function fetchItems() {
        axios.get('/api/backend/inventory/item/fetch/all/' + props.cookieEntityQr + "?type=SERVICE")
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                if (props.category) {
                    setItems(resp.data.filter(d => d.category == props.category))
                } else {
                    setItems(resp.data.filter(d => d.category != "Beds"))
                }
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    }

    const handlePostAction = () => {
        setShowItemModal(false)
        fetchItems()
    };

    const [itemType, setItemType] = useState<string>();
    const [itemName, setItemName] = useState();
    const [itemCategory, setItemCategory] = useState<string>();
    const [showItemModal, setShowItemModal] = useState(false);
    const handleRemoveItemModal = () => setShowItemModal(false);
    const handleShowItemModal = (itemType, itemName, itemCategory) => {
        setItemName(itemName)
        setItemType(itemType)
        setItemCategory(itemCategory)
        setShowItemModal(true)
    }

    function getModalForItem() {
        return <Modal
            show={showItemModal}
            onHide={handleRemoveItemModal}
            backdrop="static"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                {(itemName || (props.category != "Lab" && props.category != "Radiology")) &&
                    <MedicalServiceView cookieEntityQr={props.cookieEntityQr} type={itemType} name={itemName}
                                        category={itemCategory} postAction={handlePostAction}/>}
                {(!itemName && (props.category == "Lab" || props.category == "Radiology")) &&
                    <AddDiagnosticServicesView cookieEntityQr={props.cookieEntityQr} category={props.category}
                                               postAction={handlePostAction}/>}
            </Modal.Body>
        </Modal>;
    }

    const handleDelete = (id) => {
        axios.delete('/api/backend/inventory/item/delete/id/' + id)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                fetchItems();
                handleCloseDeleteModal();
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                setDeleteError("Something went wrong! Please try again later.")
            })
    }

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedIdForDelete, setSelectedIdForDelete] = useState();
    const [deleteError, setDeleteError] = useState(null);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);
    const handleShowDeleteModal = (selectedIdForDelete) => {
        setDeleteError(null)
        setSelectedIdForDelete(selectedIdForDelete)
        setShowDeleteModal(true)
    }

    function getModalForDeleteCase() {
        return <Modal
            show={showDeleteModal}
            onHide={handleCloseDeleteModal}
            backdrop="static"
        >
            <Modal.Body>
                <div className="fs-5 my-3 text-danger">
                    Please note that this item will not be accessible anymore.
                    Please consider using the same item and updating the stock.
                    Please confirm if you still want to proceed.
                </div>
                {deleteError && <div className="fs-7 text-danger my-3">{deleteError}</div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="btn btn-secondary" onClick={handleCloseDeleteModal}>
                    Cancel
                </Button>
                <Button variant="btn btn-primary text-white"
                        onClick={e => handleDelete(selectedIdForDelete)}>Confirm</Button>
            </Modal.Footer>
        </Modal>;
    }

    useEffect(() => {
        fetchItems();
    }, [props.cookieEntityQr])

    const ITEMS_HEADERS: TableColumnType<any>[] = [
        {
            prop: "category",
            title: "Category",
            isFilterable: true,
            isSortable: true
        },
        {
            prop: "name",
            title: "Name",
            isFilterable: true,
            isSortable: true
        },
        {
            prop: "intraStateTaxPerc",
            title: "Tax %"
        },
        {
            prop: "button",
            cell: (row) => (
                <>
                    <a href="#/" className="edit"
                       onClick={() => handleShowItemModal(row.type, row.name, row.category)}>✏️</a>&nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="#/" className="remove" onClick={e => handleShowDeleteModal(row.id)}>X</a>
                </>
            )
        }
    ];

    function getItemsTable() {
        return <div className="overflow-scroll"><DatatableWrapper
            body={items}
            headers={ITEMS_HEADERS}
            paginationOptionsProps={{
                initialState: {
                    rowsPerPage: 30,
                    options: [30, 50, 100]
                }
            }}
        >
            <Row className="mb-4 p-2">
                <Col
                    xs={12}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                    <Filter/>
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    lg={4}
                    className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0"
                >
                    <PaginationOptions/>
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                    <Pagination/>
                    <Button className="btn btn-warning text-white"
                            onClick={fetchItems}>
                        &#8634;
                    </Button>
                </Col>
            </Row>
            <Table>
                <TableHeader/>
                <TableBody/>
            </Table>
            <Row className="mt-4 p-2">
                <Col
                    xs={12}
                    sm={12}
                    lg={12}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                    <Pagination/>
                </Col>
            </Row>
        </DatatableWrapper>
        </div>;
    }

    return (
        <>
            <div className="row my-5">
                <div className="col">
                    <div className="card p-2 shadow-sm">
                        <div className="d-flex justify-content-between py-2 pr-1">
                            <h4 className="text-primary pl-1">Manage Services</h4>
                            <Button className="btn btn-warning btn-sm text-white"
                                    onClick={e => handleShowItemModal(null, null, props.category)}>+
                                Add New</Button>
                        </div>
                        {getItemsTable()}
                        {getModalForItem()}
                        {getModalForDeleteCase()}
                    </div>
                </div>
            </div>
        </>
    );
};
